import PackageAdhesionTerms from 'src/components/packageAdhesionTerms'

// Mantém o path legado apontando para o novo termo do pacote
export default PackageAdhesionTerms
